import axios from 'axios';

import AuthTotpDevicesApi, { VerifyResponse } from './authTotpDevices.types';

export const endpoint = 'api/v1/auth/totp_devices/';

const authTotpDevicesApi: AuthTotpDevicesApi = {
  verifyTotpToken: async ({ deviceId, otpToken }): Promise<VerifyResponse> => {
    const { data } = await axios.post(`${endpoint}${deviceId}/verify_token/`, { otp_token: otpToken });
    return data;
  },
  verifyAnyTotpToken: async ({ otpToken }): Promise<VerifyResponse> => {
    const { data } = await axios.post(`${endpoint}verify_any_token/`, { otp_token: otpToken });
    return data;
  },
};

export default authTotpDevicesApi;
